interface IncomeAcceptableData {
	rate: number;
	isSingleAcceptable: boolean;
}

export const INCOME_ACCEPTABLE_RATE: Record<string, IncomeAcceptableData> = {
	// Kiegészítő
	FAM: { rate: 1, isSingleAcceptable: false },
	GYES: { rate: 1, isSingleAcceptable: false },
	GYED: { rate: 1, isSingleAcceptable: false },
	CSED: { rate: 1, isSingleAcceptable: false },
	BONUS: { rate: 1, isSingleAcceptable: false },
	CAF: { rate: 1, isSingleAcceptable: false },
	ESTATE: { rate: 1, isSingleAcceptable: false },
	"DAILY-FEE": { rate: 1, isSingleAcceptable: false },
	CONGRESS: { rate: 1, isSingleAcceptable: false },

	// Önálló
	"SALARY-H": { rate: 1, isSingleAcceptable: true },
	"SALARY-X": { rate: 1, isSingleAcceptable: true },
	KATA: { rate: 0.6, isSingleAcceptable: true },
	EVA: { rate: 0.6, isSingleAcceptable: true },
	"ENT-H": { rate: 1, isSingleAcceptable: true },
	DIVIDEND: { rate: 1, isSingleAcceptable: true },
	GARDEN: { rate: 1, isSingleAcceptable: true },
	PEN: { rate: 1, isSingleAcceptable: true },
	"PEN-W": { rate: 1, isSingleAcceptable: true },
	"PEN-X": { rate: 1, isSingleAcceptable: true },
	"PEN-S": { rate: 1, isSingleAcceptable: true },
	SERVICE: { rate: 1, isSingleAcceptable: true },

	// Nem elfogadhatü
	CHILD: { rate: 0, isSingleAcceptable: false },
	COMSERV: { rate: 0, isSingleAcceptable: false },
	"ENT-X": { rate: 0, isSingleAcceptable: false },
	HANDIC: { rate: 0, isSingleAcceptable: false },
	INVALID: { rate: 0, isSingleAcceptable: false },
	"INVALID-S": { rate: 0, isSingleAcceptable: false },
	HEALTH: { rate: 0, isSingleAcceptable: false },
	"PEN-WT": { rate: 0, isSingleAcceptable: false },
	REHAB: { rate: 0, isSingleAcceptable: false },
	MINE: { rate: 0, isSingleAcceptable: false },
	NURSING: { rate: 0, isSingleAcceptable: false },
	SOCIAL: { rate: 0, isSingleAcceptable: false },
	ORP: { rate: 0, isSingleAcceptable: false },
	MOT: { rate: 0, isSingleAcceptable: false },
	FOSTER: { rate: 0, isSingleAcceptable: false },
	ANNUITY: { rate: 0, isSingleAcceptable: false },
	SCHOLAR: { rate: 0, isSingleAcceptable: false },
	OLYM: { rate: 0, isSingleAcceptable: false },
	ASSIGNMENT: { rate: 0, isSingleAcceptable: false },
	BAL: { rate: 0, isSingleAcceptable: false },
	BLIND: { rate: 0, isSingleAcceptable: false },
	CHURCH: { rate: 0, isSingleAcceptable: false },
	ACC: { rate: 0, isSingleAcceptable: false },
	FAMILY: { rate: 0, isSingleAcceptable: false },
};
